<div class="card-item">
    <ng-content></ng-content>
</div>
